import { render, staticRenderFns } from "./ExpenditureIndex.vue?vue&type=template&id=56301570&scoped=true&"
import script from "./ExpenditureIndex.vue?vue&type=script&lang=js&"
export * from "./ExpenditureIndex.vue?vue&type=script&lang=js&"
import style0 from "./ExpenditureIndex.vue?vue&type=style&index=0&id=56301570&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56301570",
  null
  
)

export default component.exports